import { useEffect } from 'react';
import styles from '../styles/AdSlot.module.css';
import { ADSENSE_ID } from '../utils/constants';

declare global {
  interface Window {
    adsbygoogle: object[];
  }
}

const AdSlot = () => {
  useEffect(() => {
    // Ad blockers (e.g. Brave Shields on iPhone) can swap Google's ad script for
    // a stand-in that throws, which would otherwise crash the whole page
    try {
      (window.adsbygoogle = window.adsbygoogle || []).push({});
    } catch {
      // No ad, but the keyboard still works
    }
  }, []);

  return (
    <>
      <div className={styles.adslot}>
        <ins
          className="adsbygoogle"
          data-ad-client={ADSENSE_ID}
          data-ad-slot="5698939148"
          data-ad-format="auto"
          data-full-width-responsive="true"
        ></ins>
      </div>
    </>
  );
};

export default AdSlot;
